import React from "react";
import Classes from "./Hero2.module.css";
import { useNavigate } from "react-router-dom";
import Box1Graph from "./Box1Graph";
import backend from "../../../../../../../api";
import { useSelector } from "react-redux";
import { useState, useEffect } from "react";

export default function Hero2() {
    const navigateTo = useNavigate();
 const { user } = useSelector((state) => state.auth);
  const [conversations, setConversations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  async function fetchConversations() {
    try {
      const response = await backend.get(`/api/chat/conversation?userId=${user._id}`);
      const convos = (response.data?.data || [])
        .filter((convo) => convo?.last?.text && convo?.last?.text.trim() !== "")
        .slice(0, 3);
      setConversations(convos);
      setLoading(false);
    } catch (err) {
      console.error("Error fetching conversations:", err);
      setError(err.response?.data?.message || "Failed to load messages");
      setLoading(false);
    }
  }

    useEffect(() => {
    if (user._id ) {
      fetchConversations();
    }
  }, [user._id]);
  
    return (
        <div className={Classes.hero}>
            {/* ───────── Left column ───────────────── */}
            <div>
                <div className={Classes.box}>
                    <Box1Graph />
                </div>
            </div>

            {/* ───────── Right column ──────────────── */}
     <div className={Classes.box}>
         <div className={Classes.header} >
            <h5>Messages</h5>
                        <button type="button" onClick={() => navigateTo('/messages')} > View all {'>'} </button>   </div>       
          {loading ? (
            <div className={Classes.center} >
              <h5 className="placeholderText" >Loading...</h5>
            </div>
          ) : <>
            {conversations && conversations.length > 0 ? (
              <ul className={Classes.messageList}>
                {conversations.map((convo) => (
                  <li key={convo._id} className={Classes.messageItem}>
                    {/* <img
                      src={convo.partnerAvatar || "https://i.pravatar.cc/80"}
                      alt={convo.partnerName}
                      className={Classes.avatar}
                    /> */}
                    <div className={Classes.messageBody}>
                      <h5 className={Classes.name}>{convo.partnerName || "Unknown"}</h5>
                      <h5 className={Classes.snippet}>{convo.last.text}</h5>
                      <h5 className={Classes.time}>
                        {new Date(convo.last.createdAt).toLocaleString([], {
                          month: "short",
                          day: "numeric",
                          hour: "2-digit",
                          minute: "2-digit",
                        })}
                      </h5>
                    </div>
                  </li>
                ))}
              </ul>
            ) : (
              <div className={Classes.emptyMessage} >
                <img src='/assets/images/empty-message.webp' alt="empty" draggable={false} />
                <h5>No recent messages</h5>
              </div>
            )}
          </>
          }

        </div>

            </div>
    );
}
